<template>

    <div class="container card p-5 shadow col-md-5 m-auto">
        
        <h1>Create TestType</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                </div>
                <input v-model="testType.title" type="text"  class="form-control" placeholder="Enter Title">
            </div>
        </div>
        <button @click="addTestType()" type="button" class="btn btn-primary mb-3">Add TestType</button>
        
    </div>

</template>

<script>
export default {
    data() {
        return {
            isKeySelected: false,
            titleTranslationKeys: [],
            testType: {
                title: null,
                titleTranslationKey: null,
                key: null
            },
            response: {},
            addKeyResponse: {},
            keyIndex: null
        }
    },
    methods: {
        addTestType: function(){
            if(this.keyIndex === -1){
                this.response = {"success": false, "message": "Given Title Translation Key is either not generated yet or not selected"}
            }
            else
            {
                let self = this;
                this.$http.post('/api/test-types/add/', this.testType)
                .then(response => {
                    self.response = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        translationKeySearch: function(){
            let self = this;
            this.$http.get('/api/languages/search/' + this.testType.titleTranslationKey)
            .then(response => {
                self.titleTranslationKeys = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        createKey: function(){
            let self = this;
            this.testType.key = this.testType.titleTranslationKey;
            this.$http.post('/api/languages/add-translation/', self.testType)
            .then(response => {
                self.addKeyResponse = response.data;
                self.translationKeySearch();
            })
            .catch(error => {
                console.log(error);
            })
        },
        selectKey: function(){
            this.keyIndex = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(this.testType.titleTranslationKey);
            this.isKeySelected = true
        },
        isKeyInTitleTranslationKeys: function(){
            var index = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(this.testType.titleTranslationKey);
            if(index >= 0)
                return true;
            else
                return false;
        }
    },
    mounted: function() {
    },
    watch: {
        // TODO: response redirection error 
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push("/admin/test-types/");
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },
        addKeyResponse: function(val){
            if(val.success === true)
            {
                this.titleTranslationKeys.push(this.testType.key);
            }
        },
        'testType.titleTranslationKey' : function(val){
            var correctVal = val.toUpperCase().replace('-', '_').replace(' ','_').replace(/[^_\dA-Z]/, '');
            if(this.testType.titleTranslationKey !== correctVal)
                this.testType.titleTranslationKey = correctVal;
            else{
            // get index of object with key: val
            this.keyIndex = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(val);  
            if(this.keyIndex === -1)
                this.isKeySelected = false;

            if(this.testType.titleTranslationKey)
                this.translationKeySearch();
            else
                this.titleTranslationKeys = [];
            }
        }
        
    }
    
}
</script>

<style lang="scss">
.autocomplete{
  position: relative;
  display: inline-block;
}
input{
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  &[type=text]
  {
    width: 100%;
  }
}

.autocomplete-items
{
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  input{
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
    &:hover{
      background-color: #e9e9e9;
    }
  }
}
.autocomplete-active{
  background-color: DodgerBlue !important;
  color: #ffffff;
}


div{
    span.input-group-text {
        width: 85px;
    }
}

.form-control[readonly] {
    background-color: white;
}
</style>
